import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { Icon, IconComponent, ImageThumbnailComponent } from '@web/shared/ui';
import {
  Route,
  RouteParam,
  RouterLinkComponent,
  RouterLinkParams,
} from '@web/common';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-public-box-cosmetic-tile',
  imports: [
    ImageThumbnailComponent,
    NgOptimizedImage,
    RouterLinkComponent,
    IconComponent,
    Tooltip,
  ],
  templateUrl: './public-box-cosmetic-tile.component.html',
  styleUrl: './public-box-cosmetic-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxCosmeticTileComponent {
  public readonly brandName = input.required<string>();
  public readonly brandSlug = input.required<string>();
  public readonly slug = input.required<string>();
  public readonly imageSrc = input.required<string>();
  public readonly imageAlt = input.required<string>();
  public readonly name = input.required<string>();

  /* prettier-ignore */
  protected readonly cosmeticRouterLinkParams = this.cosmeticRouterLinkParamsSignal();
  protected readonly brandRouterLinkParams = this.brandRouterLinkParamsSignal();
  protected readonly Route = Route;
  protected readonly Icon = Icon;

  private cosmeticRouterLinkParamsSignal(): Signal<RouterLinkParams> {
    return computed(() => ({
      [RouteParam.Slug]: this.slug(),
    }));
  }

  private brandRouterLinkParamsSignal(): Signal<RouterLinkParams> {
    return computed(() => ({
      [RouteParam.Slug]: this.brandSlug(),
    }));
  }
}
